import Payment from '@/views/Payment.vue';
import Success from '@/views/SuccessPayment.vue';

const paymentRoutes = [
  {
    path: '/payment/:id',
    name: 'payment',
    component: Payment,
  },
  {
    path: '/success/:reference',
    name: 'success',
    component: Success,
  },
];

export default paymentRoutes;
